module.exports = __webpack_public_path__ + "static/media/cl.b12b81fa.webp";